<template>
    <div class="bg">
        <div class="h-100 d-flex flex-column justify-center align-center">
            <img :src="whiteLogo" alt="logo" width="110" class="my-2" />
            <span class="white--text my-2">
                {{ info.AssistantName }} مرحبا
            </span>
            <v-btn
                class="rounded-xl my-2"
                color="secondary"
                @click="isStart = true; startOrEndTransport(isStart)"
                :loading="submitLoading && isStart"
                :disabled="submitLoading && !isStart"
            >
                بدء رحلة الذهاب
            </v-btn>
            <v-btn
                class="rounded-xl my-2"
                color="secondary"
                @click="isStart = false; startOrEndTransport(isStart)"
                :loading="submitLoading && !isStart"
                :disabled="submitLoading && isStart"
            >
                بدء رحلة العودة
            </v-btn>

            <v-alert v-if="alert" dismissible color="orange white--text" class="rounded-BigLg" width="300   ">
                يبدو أن إشعارات المتصفح معطلة. لتتمكن من تلقي الإشعارات المهمة من هذا الموقع، يرجى تفعيل الإشعارات من إعدادات المتصفح لديك.
            </v-alert>
        </div>
        <!-- footer -->
        <div class="d-flex justify-end mb-2">
            <v-bottom-navigation v-model="navigationBottom" color="primary" width="70" height="auto" class="elevation-0" >
                <a href="https://www.facebook.com/edunix.system" target="_blank">
                    <v-img src="@/assets/Powered By Edunix (Black).png" width="50" />
                </a>
            </v-bottom-navigation>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { whiteLogo } from '@/config/config.js'
import moment from 'moment'
export default {
    data () {
        return {
            navigationBottom: true,
            submitLoading: false,
            isStart: true,
            whiteLogo,
            permission: null,
            alert: false
        }
    },

    computed: {
        ...mapState({
            info: state => state.auth.info,
            centerId: state => state.auth.centerId,
            notifications: state => state.notification.notifications
        })
    },

    methods: {
        moment,
        askForNotificationPermission () {
            if (Notification.permission === 'granted') {
                this.permission = 'granted'
            } else if (Notification.permission === 'denied') {
                this.permission = 'denied'
            } else {
                Notification.requestPermission().then(permission => {
                    this.permission = permission
                })
            }
        },
        startOrEndTransport () {
            this.submitLoading = true
            this.$store.dispatch('transport/startOrEndTransport', {
                centerId: localStorage.getItem('centerId'),
                userName: localStorage.getItem('userName')
            }).then(() => {
                this.$store.dispatch('notification/getNotification', {
                    centerId: localStorage.getItem('centerId'),
                    userName: localStorage.getItem('userName'),
                    dateTime: moment().format('YYYY-MM-DD')
                }).then((data) => {
                    console.log('noti true')
                    if (data.data.length > 0 && data.data.filter(c => c.TripType === 0 || (this.isStart === true ? c.TripType === 1 : c.TripType === 2).length > 0)) {
                        console.log('noti > 0')
                        if (Notification.permission === 'default') {
                            console.log('def')
                            Notification.requestPermission()
                        } else if (Notification.permission === 'denied') {
                            this.alert = true
                        } else {
                            // eslint-disable-next-line no-new
                            new Notification('New Notification', {
                                body: this.isStart === true
                                    ? 'تم نقل مجموعة من الطلاب من حافلتك إلى حافلة أخرى في رحلة الذهاب. يرجى مراجعة قسم الإشعارات للاطلاع على التفاصيل والتأكد من قائمة الطلاب المحدثة..'
                                    : 'تم نقل مجموعة من الطلاب من حافلتك إلى حافلة أخرى في رحلة العودة. يرجى مراجعة قسم الإشعارات للاطلاع على التفاصيل والتأكد من قائمة الطلاب المحدثة. '
                            })
                        }
                    } else {
                        console.log('<')
                    }
                    this.submitLoading = false
                    this.$router.replace({
                        name: 'student-page',
                        query: {
                            isStart: this.isStart
                        }
                    })
                }).catch(() => {
                    this.submitLoading = false
                    this.$router.replace({
                        name: 'student-page',
                        query: {
                            isStart: this.isStart
                        }
                    })
                })
            }).catch(() => {
                this.submitLoading = false
            })
        }
    },

    created () {
        this.permission = Notification.permission
    }
}
</script>

<style lang="scss">
@import '@/scss/variables.scss';
.bg {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: $background-color;
    border-bottom-left-radius: 165px;
}
</style>
